/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'programm': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#606060" stroke-width="1.5"><path pid="0" d="M.75.75h18.5v18.5H.75z"/><path pid="1" stroke-linecap="square" d="M4.5 5.469h11.355M4.5 8.998h11.355M4.5 12.528h11.355"/></g>'
  }
})
